import { render, staticRenderFns } from "./groupPurcharseOrder.vue?vue&type=template&id=e84c56be&scoped=true"
import script from "./groupPurcharseOrder.vue?vue&type=script&lang=js"
export * from "./groupPurcharseOrder.vue?vue&type=script&lang=js"
import style0 from "./groupPurcharseOrder.vue?vue&type=style&index=0&id=e84c56be&prod&lang=less&scoped=true"
import style1 from "./groupPurcharseOrder.vue?vue&type=style&index=1&id=e84c56be&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84c56be",
  null
  
)

export default component.exports